import React, { useCallback, useState, useRef, useEffect } from 'react-x';
import PropTypes from 'prop-types-x';

export function Image(props) {
  
  const { alt, className, imageUrl, fallBackImageUrl, onErrorFn, options, testId, onClick, onLoad } = props;
  const defaultFallback = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  const hasMountedRef = useRef();
  const [ imageSrc, setImageSrc ] = useState(imageUrl || fallBackImageUrl);
  const [ hasLoaded, setHasLoaded ] = useState(false);

  const onError = useCallback(e => {
    if (onErrorFn) {
      onErrorFn(e);
      return;
    }
    if (e.target.src === imageUrl && fallBackImageUrl && imageUrl !== fallBackImageUrl) {
      setImageSrc(fallBackImageUrl);
    } else {
      setImageSrc(defaultFallback);
    }
  }, [fallBackImageUrl, imageUrl, defaultFallback]);

  useEffect(() => {
    if (hasMountedRef.current) {
      setImageSrc(imageUrl);
    }
  }, [imageUrl]);

  // trick to set a "hasmounted" flag: keep as last useEffect
  useEffect(() => { 
    hasMountedRef.current = true; 
  }, []);

  return (
    <img alt={alt} {...{
      className: className,
      src: imageSrc,
      onClick,
      onError,
      loading: options?.shouldLazyLoad ? 'lazy' : 'eager',
      draggable: false,
      onLoad: (event) => {
        setHasLoaded(true);
        onLoad(event);
      },
      'data-test-id': testId
    }}
    />
  )
};

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  fallBackImageUrl: PropTypes.string,
  onClick: PropTypes.func,
  onErrorFn: PropTypes.func,
  testId: PropTypes.string,
  onLoad: PropTypes.func
};

Image.defaultProps = {
  alt: 'image',
	onClick: () => {},
  onLoad: () => {}
};